import React from 'react'
import { LuArrowLeftRight, LuLayoutGrid, LuUsers } from 'react-icons/lu'

import teamIcon from '@/assets/img/icons/clients.svg'
import SvgImage from '@/components/misc/SvgImage'
import { useNotificationsCount } from '@/hooks/useNotificationsCount'
import { GROUP_DASHBOARD_SIDEBAR_LINKS } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'
import { SidebarLink } from '@/types/misc'

export function useGroupDashboardSidebarLinks() {
  const notificationsCount = useNotificationsCount()

  const overviewLink: SidebarLink = {
    title: GROUP_DASHBOARD_SIDEBAR_LINKS.overview,
    href: ROUTES.groupOverview(),
    icon: <LuUsers size={18} />,
  }

  const dashboardLink: SidebarLink = {
    title: GROUP_DASHBOARD_SIDEBAR_LINKS.dashboard,
    href: ROUTES.groupDashboard(),
    icon: <LuLayoutGrid size={18} />,
  }

  const referralsLink: SidebarLink = {
    title: GROUP_DASHBOARD_SIDEBAR_LINKS.referrals,
    href: ROUTES.referrals(),
    icon: <LuArrowLeftRight className="size-4" />,
    badge:
      notificationsCount.referrals > 0
        ? `${notificationsCount.referrals}`
        : undefined,
  }

  const teamManagementLink: SidebarLink = {
    title: GROUP_DASHBOARD_SIDEBAR_LINKS.teamManagement,
    href: '#',
    icon: (
      <SvgImage
        src={teamIcon}
        alt={GROUP_DASHBOARD_SIDEBAR_LINKS.teamManagement}
      />
    ),
    comingSoonText: 'Team Management is coming soon',
    style: { opacity: 0.4 },
  }

  return [overviewLink, dashboardLink, referralsLink, teamManagementLink]
}
